import { BaseState } from "..";
import { PaymentResult } from "../../app/data/payment/PaymentResult";
import { TokenInfo } from "../../app/data/payment/TokenInfo";
import {
  AchBankDetails,
  PaymentMethodOption,
  PaymentStatusResponse,
} from "../../app/data/payment/PaymentSession";

export default interface PaymentState extends BaseState {
  showPopup: boolean;
  showMethodPicker: boolean;
  hiddenFormSubmitted: boolean;
  paymentResult: PaymentResult | null | undefined;
  tokenInfo: TokenInfo | null | undefined;
  error: string | null | undefined;
  paymentSum: number | undefined;
  paymentInitiator: string | undefined;
  timedOut: boolean;
  blockedInvoices: Record<string, boolean>;
  pendingInvoiceNumbers: number[];
  surchargeWarning: string;
  surchargeEnabled: boolean;
  achBankDetails: AchBankDetails;
  availableMethods: PaymentMethodOption[];
  sessionPaymentId: string | null;
  confirmStatus: PaymentStatusResponse | null;
}

export const DEFAULT_SURCHARGE_WARNING =
  "Please Note credit card payments may have additional charges applied";

export const EMPTY_ACH_BANK_DETAILS: AchBankDetails = {
  bankName: "",
  accountName: "",
  routingNumber: "",
  accountNumber: "",
  accountType: "Checking",
};

export const initialPaymentState: PaymentState = {
  loading: false,
  loadingFailed: false,
  loaded: false,
  showPopup: false,
  showMethodPicker: false,
  hiddenFormSubmitted: false,
  paymentResult: null,
  tokenInfo: null,
  error: null,
  paymentSum: 0,
  paymentInitiator: undefined,
  timedOut: false,
  blockedInvoices: {},
  pendingInvoiceNumbers: [],
  surchargeWarning: DEFAULT_SURCHARGE_WARNING,
  surchargeEnabled: true,
  achBankDetails: EMPTY_ACH_BANK_DETAILS,
  availableMethods: [],
  sessionPaymentId: null,
  confirmStatus: null,
};
